// sidebarItems.js
import DashboardIcon from "../image/Dashboards.png";
import BookingIcon from "../image/Booking.png";
import EnquiryIcon from "../image/Enquiry.png";
import WarehouseIcon from "../image/Warehouse.png";
import UserProfileIcon from "../image/UserProfile.png";
import MasterDataIcon from "../image/MasterData.png";
import FreightIcon from "../image/Freight.png";
import SalesIcon from "../image/Sales.png";
import ChaRequestsIcon from "../image/ChaRequests.png";
import CustomsIcon from "../image/Customs.png";
import WarehousingIcon from "../image/Warehousing.png";
import TruckingIcon from "../image/Trucking.png";
import HyperlocalIcon from "../image/Hyperlocal.jpg";
import ContainerIcon from "../image/Container.png";
import VesselIcon from "../image/Vessel.png";
import FinanceIcon from "../image/Finance.png";
import MarketplaceIcon from "../image/Marketplace.png";
import PortoperationsIcon from "../image/Portoperations.jpg";
import BillingInvoiceIcon from "../image/BillingInvoice.png";
import AnalyticsIcon from "../image/Analytics.png";
import CustomerExperienceIcon from "../image/CustomerExperience.png";
import PartnerOnboardingIcon from "../image/PartnerOnboarding.png";
import CompliancesecuIcon from "../image/Compliancesecu.png";
import RiskmanageIcon from "../image/Riskmanage.png";
import NotificationIcon from "../image/Notification.png";
import AutomationIcon from "../image/Automation.png";
import MyProfileIcon from "../image/MyProfile.png";
import SalesAmountIcon from "../image/SalesAmount.png"
 
export const sidebarItems = [
  // ================= User =================
  {
    title: "Dashboard",
    icon: DashboardIcon,
    path: "/",
    roles: ["User", "Admin", "SuperAdmin", "sales_rep", "wh_owner", "wh_manager", "cha_admin"],
  },

  {
    title: "Sales Dashboard",
    icon: SalesAmountIcon,
    path: "/sales-dashboard",
    roles: ["SuperAdmin"],
  },
  {
    title: "Analytical Intelligence",
    icon: AnalyticsIcon,
    path: "/intelligence",
    roles: ["Admin", "SuperAdmin"],
  },
  {
    title: "My Enquiry",
    icon: EnquiryIcon,
    roles: ["User"],
    profileStatus: "Verified",
    submenus: [
      { title: "Create Enquiry", path: "/my-enquiry/create-enquiry" },
      { title: "View Enquiry", path: "/my-enquiry/view-enquiry" },
    ],
  },
  {
    title: "My Booking",
    icon: BookingIcon,
    roles: ["User"],
    profileStatus: "Verified",
    submenus: [
      { title: "View Bookings", path: "/my-bookings/list-of-bookings" },
      // { title: "View Bookings Details", path: "/my-bookings/view-bookings" },
      { title: "View BL Draft", path: "/my-bookings/list-of-bl" },
      // { title: "View BL Draft", path: "/my-bookings/view-bl-draft" },
    ],
  },
  {
    title: "Warehouse",
    icon: WarehouseIcon,
    path: "/warehouse",
    roles: ["User"],
    profileStatus: "Verified",
    submenus: [
      { title: "Create Request", path: "/Create-warehouses-request" },
      
      { title: "My Requests", path: "/warehouse-requests" },
      
    ],
  },
  {
    title: "User Profile",
    icon: UserProfileIcon,
    path: "/user-profile",
    roles: ["User"],
  },
 
 
  //================ Sales_Rep ==============
  {
     title: "Freight Enquiries",
     icon: FreightIcon,
     path: "/freight-enquiries",
     roles: ["sales_rep"],
  },
 
  // ================= ADMIN =================
  {
    title: "Master Data",
    icon: MasterDataIcon,
    roles: ["Admin", "SuperAdmin"],
    submenus: [
{ title: "Exchange Rate", path: "/master-data/exchange-rate" },
       { title: "Charge Code", path: "/master-data/charge-code" },
       { title: "Vendor Master", path: "/master-data/vendor-master" },
       { title: "Job Master", path: "/master-data/job-master" },
       { title: "Client Master", path: "/master-data/client-master" },
       { title: "User Master", path: "/master-data/user-master" },
       { title: "Terms & Conditions", path: "/master-data/terms-and-conditions" },
       { title: "Port List", path: "/master-data/ports" },
    ],
  },
// {
//     title: "Billing & Invoice",
//     icon: BillingInvoiceIcon,
//     roles: ["SuperAdmin"],
//     submenus: [
//       { title: "Invoicing", path: "/billingAndInvoice/invoicing" },
//       { title: "Payment Gateway", path: "/billingAndInvoice/paymentGateway" },
//       {
//         title: "Dispute&Reconciliation",
//         path: "/billingAndInvoice/disputeAndReconciliation",
//       },
//       { title: "Tally", path: "/billingAndInvoice/tally" },
//     ],
//   },

{
    title: "Finance",
    icon: BillingInvoiceIcon,
    roles: ["SuperAdmin"],
    submenus: [
      { title: "Billing & Accounting", path: "/billingAndInvoice/invoicing" },
      { title: "Payment Gateway", path: "/billingAndInvoice/paymentGateway" },
      { title: "Trade Credit", path: "/billingAndInvoice/paymentGateway" },
      { title: "Insurance", path: "/billingAndInvoice/paymentGateway" },
      { title: "Claims Dispute", path: "/billingAndInvoice/paymentGateway" },
      { title: "Expense Manage", path: "/billingAndInvoice/paymentGateway" },
      { title: "Tally", path: "/billingAndInvoice/tally" },
    ],
  },

  {
    title: "Freight",
    icon: FreightIcon,
    roles: ["Admin", "SuperAdmin" ],
    submenus: [
      { title: "Pending Enquiries", path: "/freight/pending-enquiries" },
      { title: "View Booking", path: "/freight/view-booking/admin" },
      { title: "Sl(BL)", path: "/list-of-bl/admin" },
  
    ],
  },
 
  {
    title: "Warehouse",
    icon: WarehousingIcon,
    path: "/list-wh-admin",
    roles: ["SuperAdmin"],
   
  },
  // ================= SUPER ADMIN =================
 
  {
    title: "CHA Requests",
    icon: ChaRequestsIcon,
    path: "/cha-requests",
    roles: ["SuperAdmin"],
  },
 
  {
    title: "Customs",
    icon: CustomsIcon,
    roles: ["SuperAdmin"],
    submenus: [
      { title: "CHA Booking & Services", path: "/customs/chabookingServices" },
      { title: "Customs Clearance", path: "/customs/customsClearance" },
      { title: "Bonded Warehouse", path: "/customs/bondedWarehouse" },
      { title: "Document filing", path: "/customs/documentFiling" },
    ],
  },
 
  {
    title: "Warehousing",
    icon: WarehousingIcon,
    roles: ["SuperAdmin"],
    submenus: [
      { title: "Slot Booking", path: "/warehousing/slotBooking" },
      {
        title: "Inventory Management",
        path: "/warehousing/inventoryManagement",
      },
      { title: "WMS Integration", path: "/warehousing/wmsIntegration" },
      {
        title: "Storagein/out flow Tracking",
        path: "/warehousing/storagein-outflowTracking",
      },
      { title: "Contracting Module", path: "/warehousing/contractingModule" },
    ],
  },
 
  {
    title: "Trucking",
    icon: TruckingIcon,
    roles: ["SuperAdmin"],
    submenus: [
      { title: "Load Booking", path: "/trucking/loadBooking" },
      { title: "Truck Tracker", path: "/trucking/truckTracker" },
      { title: "Fleet Management", path: "/trucking/fleetManagement" },
      { title: "Dispute Resolution", path: "/trucking/disputeResolution" },
    ],
  },
 
  {
    title: "HyperLocal",
    icon: HyperlocalIcon,
    roles: ["SuperAdmin"],
    submenus: [
      {
        title: "Parcel Booking/Courier",
        path: "/hyperLocal/parcelbookingCourier",
      },
      { title: "Fleet/Tracking", path: "/hyperLocal/fleetTracking" },
      { title: "Notification System", path: "/hyperLocal/notificationSystem" },
      { title: "Fleet Management", path: "/hyperLocal/fleetManagement" },
    ],
  },
 
  {
    title: "Containers",
    icon: ContainerIcon,
    roles: ["SuperAdmin"],
    submenus: [
      {
        title: "Booking(Port, Rail, Yard)",
        path: "/containers/booking-port-rail-yard",
      },
      { title: "Visibility", path: "/containers/visibilityStatus" },
      {
        title: "Lifecycle Management",
        path: "/containers/lifecycleManagement",
      },
      { title: "Depot Integration", path: "/containers/depotIntegraton" },
    ],
  },
 
  {
    title: "Vessel Operations",
    icon: VesselIcon,
    roles: ["SuperAdmin"],
    submenus: [
      {
        title: "Vessel Schedule And Booking",
        path: "/vesselOperations/vesselscheduleAndBooking",
      },
      { title: "Vessel Routing", path: "/vesselOperations/vesselRouting" },
      { title: "Crew Management", path: "/vesselOperations/crewManagement" },
      {
        title: "Procurement Request",
        path: "/vesselOperations/procurementRequest",
      },
      {
        title: "Vessel Management",
        path: "/vesselOperations/vesselManagement",
      },
      {
        title: "Berth Slot Management",
        path: "/vesselOperations/berthSlothManagement",
      },
    ],
  },
 
  {
    title: "Finance",
    icon: FinanceIcon,
    roles: ["SuperAdmin"],
    submenus: [
      {
        title: "Insurance Marktetplace",
        path: "/finance/insuranceMarketplace",
      },
      {
        title: "Working Capital Credit Line",
        path: "/finance/workingCapitalCreditLine",
      },
      { title: "Embedded Finance", path: "/finance/embeddedFinance" },
      {
        title: "Loan And Credit Partner Integration",
        path: "/finance/loanAndCreditPartnerIntegration",
      },
      { title: "Cost Estimator Tool", path: "/finance/costEstimatorTool" },
    ],
  },
 
  {
    title: "Marketplace",
    icon: MarketplaceIcon,
    roles: ["SuperAdmin"],
    submenus: [
      { title: "Procurement", path: "/marketplace/procurement" },
      { title: "Quotation/Requests", path: "/marketplace/quotationRequests" },
      { title: "Bidding System", path: "/marketplace/biddingSystem" },
    ],
  },
 
  {
    title: "Port Operations",
    icon: PortoperationsIcon,
    roles: ["SuperAdmin"],
    submenus: [
      {
        title: "Docking Request Booking System",
        path: "/portOperations/dockingrequestbookingSystem",
      },
      {
        title: "Container Yard Scheduling",
        path: "/portOperations/containeryardScheduling",
      },
      { title: "Gate Entry/Exit", path: "/portOperations/gateEntryExit" },
      { title: "Token Generation", path: "/portOperations/tokenGeneration" },
      {
        title: "Port Resource Planning",
        path: "/portOperations/portResourcePlanning",
      },
],
  },

  {
    title: "Analytics",
    icon: AnalyticsIcon,
    roles: ["SuperAdmin"],
    submenus: [
      {
        title: "Control Tower Dashboard",
        path: "/analytics/controltowerDashboard",
      },
      { title: "Delays & Exceptions", path: "/analytics/delaysAndExceptions" },
      { title: "Custom MIS", path: "/analytics/customMIS" },
      {
        title: "KPI Tracker per Service",
        path: "/analytics/kpitrackerperService",
      },
      {
        title: "Partner Performance Metrics",
        path: "/analytics/partnerperformanceMetrics",
      },
    ],
  },
 
  {
    title: "Customer Experience",
    icon: CustomerExperienceIcon,
    roles: ["SuperAdmin"],
    submenus: [
      {
        title: "Customer Self Service Portal",
        path: "/customerExperience/customerselfservicePortal",
      },
      {
        title: "Service Request & Tracking",
        path: "/customerExperience/servicerequestAndTracking",
      },
      {
        title: "Escalation Matrix",
        path: "/customerExperience/escalationMatrix",
      },
      { title: "Chats", path: "/customerExperience/chats" },
      { title: "NPS Feedback", path: "/customerExperience/npsFeedback" },
    ],
  },
 
  {
    title: "Partner Onboarding",
    icon: PartnerOnboardingIcon,
    roles: ["SuperAdmin"],
    submenus: [
      { title: "Vendor KYC", path: "/partnerOnboarding/vendorKYC" },
      { title: "Documentation", path: "/partnerOnboarding/documentation" },
      {
        title: "Partner Contracting & Pricing Upload",
        path: "/partnerOnboarding/partnercontractingAndpricingUpload",
      },
      {
        title: "Slot Configuration",
        path: "/partnerOnboarding/slotConfiguration",
      },
      {
        title: "API Access Controls",
        path: "/partnerOnboarding/apiaccessControls",
      },
    ],
  },
 
  {
    title: "compliance & Security",
    icon: CompliancesecuIcon,
    roles: ["SuperAdmin"],
    submenus: [
      { title: "GST Compliance", path: "/complianceAndSecurity/gstCompliance" },
      { title: "Document Vault", path: "/complianceAndSecurity/documentVault" },
      { title: "SLA Monitoring", path: "/complianceAndSecurity/slaMonitoring" },
    ],
  },
 
  {
    title: "AI/ML & Automation",
    icon: AutomationIcon,
    roles: ["SuperAdmin"],
    submenus: [
      { title: "ETA Prediction", path: "/aiMlAndAutomation/etaPrediction" },
      { title: "Load Matching", path: "/aiMlAndAutomation/loadMatching" },
      { title: "Fraud Detection", path: "/aiMlAndAutomation/fraudDetection" },
      { title: "Credit Detection", path: "/aiMlAndAutomation/creditDetection" },
      { title: "OCR", path: "/aiMlAndAutomation/ocr" },
      { title: "Rate Generation", path: "/aiMlAndAutomation/rateGeneration" },
    ],
  },
 
  {
    title: "Risk Management",
    icon: RiskmanageIcon,
    roles: ["SuperAdmin"],
    submenus: [{ title: "Risk Alerts", path: "/riskManagement/riskAlerts" }],
  },
 
  {
    title: "Notifications",
    icon: NotificationIcon,
    roles: ["SuperAdmin"],
  },
 
//================ wh_owner ==============
 
 {
    title: "My Warehouse",
    icon:  WarehouseIcon,
    path: "/my-warehouses",
    roles: ["wh_owner"],
  },
  
  {
    title: "Warehouse Requests",
    icon: WarehousingIcon,
    path: "/warehouse-requests-owner",
    roles: ["wh_owner"],
   
  },

  {
    title: "Warehouse Bookings",
    icon: BookingIcon,
    path: "/warehouse-bookings",
    roles: ["wh_manager"],
  },

  {
    title: "CHA Services Requests",
    icon: BookingIcon,
    path: "/cha-services-requests",
    roles: ["cha_admin"],
  },
  {
    title: "My Profile",
    icon: MyProfileIcon,
    path: "/my-profile",
    roles: ["Admin", "SuperAdmin", "sales_rep", "wh_owner", "wh_manager", "cha_admin"],
  },

  ];